import { ReactNode } from 'react';
import { shgTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={shgTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
